import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ApContentModule, ApContentService } from '@ap/content';
import { Betaalverzoek, Crediteur } from '@ap/interface-apic-betaalverzoek';
import { ApAmountInputComponent } from '@ap/input/amount';
import { ApIbanPipe } from '@ap/formatters';
import { ApKeyValueModule } from '@ap/key-value';

import sharedContent from '../shared.content.json';

import content from './open-amount.content.json';

/**
 * @ngdoc component
 * @name OpenAmountComponent
 *
 * @description
 * Component that provides functionality to display payment-request details
 */
@Component({
    selector: 'open-amount',
    templateUrl: './open-amount.component.html',
    imports: [ApAmountInputComponent, ApContentModule, ApIbanPipe, ApKeyValueModule, CommonModule, FormsModule, ReactiveFormsModule]
})
export class OpenAmountComponent implements OnInit {
    @Input()
    public betaalverzoek: Betaalverzoek;
    @Input()
    public openAmountFormControl: FormControl<number>;

    public constructor(private readonly contentService: ApContentService) {}

    ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.contentService.addContentItems(sharedContent);
    }

    public getWeergavenaam(crediteur: Crediteur): string {
        return crediteur?.weergavenaam ?? this.contentService.get('open-amount.fallback.name-not-available');
    }

    public getOpenAmountText(): string {
        return this.contentService.interpolate(this.contentService.get('open-amount.text'), {
            description: this.betaalverzoek.omschrijving,
            name: this.getWeergavenaam(this.betaalverzoek.crediteur)
        });
    }
}
